import React from 'react'

interface ScrollableProps {
  outerClassName?: string
  innerClassName?: string
  children?: React.ReactNode
  overflow?: 'auto' | 'y' | 'x' | 'hidden'
  overflowXVisible?: boolean
}

function getOverflowStyle (overflow?: string): React.CSSProperties {
  if (overflow === 'hidden') return { overflowY: 'hidden', overflowX: 'hidden' }
  if (overflow === 'y') return { overflowY: 'auto' }
  if (overflow === 'x') return { overflowX: 'auto' }
  return { overflow: 'auto' }
}

function Scrollable (props: ScrollableProps) {
  const overflowStyle = React.useRef(getOverflowStyle(props.overflow))

  return (
    <div
      className={`${props.outerClassName || ''} relative height-100 ${props.overflowXVisible ? '' : 'overflow-hidden'}`}
      style={props.overflowXVisible ? { overflowY: 'clip' } : undefined}
    >
      <div
        style={overflowStyle.current}
        className={`${props.innerClassName || ''} absolute top-0 bottom-0 width-100`}
      >
        {props.children}
      </div>
    </div>
  )
}

export default Scrollable
